import { DataAnalomy } from './dataanamoly';

export class DataAnalomyRequest {
    tosave: DataAnalomy[];
    constructor() {
        this.tosave = new Array<DataAnalomy>();
    }
}




// WEBPACK FOOTER //
// ./src/app/catalogue/dataanamoly/model/dataanamolyRequest.ts